import React from 'react';
import './App.css';
import CorkBoard from './components/CorkBoard';
import { MiniKitProvider } from './components/MiniKitProvider';

// Main App component wrapped with MiniKitProvider for MiniKit functionality
function App() {
  return (
    <MiniKitProvider>
      <div className="App">
        <CorkBoard />
      </div>
    </MiniKitProvider>
  );
}

export default App;
